import { useNavigate } from "react-router-dom";
import "./Menu.css";
import logo from "./assets/splash-logo.png"; 
import eclipse from "./assets/splash-eclipse.png";


const Menu = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/levels", { state: { mode: "continue" } });
  };

  const handleNewGame = () => {
    localStorage.setItem("lastPlayedLevel", "1");
    navigate("/levels", { state: { mode: "new" } });
  };

  const handleChooseLevel = () => {
    navigate("/levels", { state: { mode: "free" } });
  };

  return (
    <div className="menu-container">
      <img src={eclipse} alt="Background shape" className="menu-eclipse" />
      <div className="menu-box">
        <img src={logo} alt="Game Logo" className="menu-logo" />
        <button className="menu-button" onClick={handleContinue}>Continue</button>
        <button className="menu-button" onClick={handleNewGame}>New Game</button>
        <button className="menu-button" onClick={handleChooseLevel}>Choose Level</button>
        <button className="menu-button" onClick={() => navigate("/howtoplay")}>How to Play</button>
      </div>
    </div>
  );
};

export default Menu;
